module.exports = ".modal-dialog {\n  width: 65%;\n  max-height: 95%;\n  max-width: none;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/guarantees-account-client/insert-guarantee-account-client/insert-guarantee-modal.component.scss
// module id = ./src/app/account-client/component/account-client-details/guarantees-account-client/insert-guarantee-account-client/insert-guarantee-modal.component.scss
// module chunks = main